jQuery( document ).ready(function() {

  $(".produitsparcategorie_ptrigger").click(function(){
    $('.produitsparcategorie_popup').show();
  });
  $('.produitsparcategorie_popup').click(function(){
    $('.produitsparcategorie_popup').hide();
  });
  $('.produitsparcategorie_pclose').click(function(){
    $('.produitsparcategorie_popup').hide();
  });

});